var _path;

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.829 7.516l-2.345-2.344A3.988 3.988 0 0029.656 4c-1.024 0-2.048.39-2.828 1.171l-4.656 4.656L20 11.999 4.803 27.195l-.794 7.139a1.5 1.5 0 001.656 1.657l7.134-.788L28 20l2.171-2.171 4.656-4.656a4 4 0 000-5.657zm-23.407 24.82l-4.224.467.47-4.23L22.122 14.12l1.939-1.939 3.759 3.76-1.939 1.938-14.458 14.458zm21.285-21.285l-2.768 2.768-3.758-3.759 2.768-2.767a.996.996 0 011.413 0l2.345 2.344a1 1 0 010 1.414z"
  })));
}

export default SvgEdit;